<div class="thankyouWrapper text-center">
    <button class="closebtn" mat-dialog-close color="primary" mat-icon-button><mat-icon>close</mat-icon></button>
    <img src="../../../assets/main/tickicon.svg" alt="Submitted">
    <!-- <h2>Submitted Successfully</h2>
    <p>We will get back to you in 2-3 business days</p> -->
    <p>Your Service Request Ref. No.:{{popupdata.refno}}</p>
    <div class="popupContentWrapper"  [innerHTML]="popupdata?.popup_html"></div>
</div>